export default "__VITE_ASSET__6BOab$gF__"